import React from 'react';
import { User } from '../../../../../../../entities/User';
import { Scorecard } from '../../../../../../../entities/applicant_tracking/Scorecard';
import { ScorecardQuestion } from '../../../../../../applicant_tracking/Scorecards/ScorecardPage/ScorecardBody/ScorecardQuestion';
import { FeedbackBlockFooter } from '../../../FeedbackBlockFooter';

interface PropTypes {
  currentUser: User;
  scorecard: Scorecard;
  viewAllScorecards: boolean;
}

export function ScorecardBody(props: PropTypes) {
  return (
    <div className='scorecard-body'>
      {props.scorecard.survey?.sections.map((section) => {
        return (
          <ScorecardQuestion
            {...props}
            key={section.id}
            user={props.currentUser}
            section={section}
            fillColorClass='text-rating-color'
            readonly={true}
            disabled={true}
          />
        );
      })}
      <FeedbackBlockFooter
        currentUser={props.currentUser}
        entryUser={props.scorecard.user}
        updatedAt={props.scorecard.updatedAt}
      />
    </div>
  );
}
